var map = {
	"./about.png": 61754,
	"./contact.png": 85104,
	"./s1.png": 1551,
	"./ser1.jpg": 613,
	"./service.png": 92873,
	"./shape.png": 22588,
	"./shape2.png": 2834,
	"./soft1.png": 24736,
	"./soft2.png": 70178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40732;